module.exports = __webpack_public_path__ + "img/badge_gray_txcan-finaid.50665daf.svg";